// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"KY-z","subtitle":"LY-z","wrapper":"MY-z","leftArrow":"NY-z","rightArrow":"OY-z"};